import React from 'react';

import { isUndefined } from 'lodash';
import { Button, Icon, SemanticCOLORS, SemanticICONS } from 'semantic-ui-react';

import registerButtonStyles from 'global-components/register/RegisterButtonStyles';
import { TaskAssignStatusFilter } from 'task/OhsTaskTypes';
import { ModuleType } from 'global-services/constants/OhsObject';
import OhsTaskAssignHook from 'task/hooks/OhsTaskAssignHook';
import { useAppDispatch } from 'app/hooks';
import {
  clearTaskAssign,
  setOnAssignModalCloseFunc,
  toggleAssignModalOpen,
} from 'task/store/OhsTaskAssignSlice';

interface Props {
  name?: string;
  color?: SemanticCOLORS;
  recordId: string;
  taskId: string;
  recordType: ModuleType;
  onModalCloseFunc?: () => void;
  icon?: SemanticICONS;
  disabled?: boolean;
}
function OhsAssignModalButton(props: Props) {
  const { classes } = registerButtonStyles();
  const dispatch = useAppDispatch();
  const { getTaskAssignStatus, setTaskAssignInfo } = OhsTaskAssignHook();
  const loadTaskAssign = () => {
    dispatch(clearTaskAssign());
    const taskStatusObject: TaskAssignStatusFilter = {
      _id: props.taskId,
      for: { _id: props.recordId, type: props.recordType },
    };
    getTaskAssignStatus(taskStatusObject);
    setTaskAssignInfo(taskStatusObject);
  };
  const handleAssign = () => {
    dispatch(toggleAssignModalOpen(true));
    if (!isUndefined(props.onModalCloseFunc))
      dispatch(setOnAssignModalCloseFunc(props.onModalCloseFunc));
  };

  React.useEffect(() => {
    loadTaskAssign();
  }, []);

  return (
    <Button
      className={classes.button}
      color={props.color}
      onClick={handleAssign}
      disabled={props.disabled}
    >
      {props.icon && (
        <Icon
          className={
            `${props.name}` === ''
              ? `${classes.iconOnly} ${classes.buttonIcons}`
              : classes.buttonIcons
          }
          name={props.icon}
        />
      )}
      {props.name && <span className={classes.hideForSmall}>{props.name}</span>}
    </Button>
  );
}

OhsAssignModalButton.defaultProps = {
  name: undefined,
  icon: undefined,
  onModalCloseFunc: undefined,
  color: 'grey',
  disabled: false,
};

export default OhsAssignModalButton;
